/* src/app/components/substances-warnings/substances-warnings.component.scss */
.table > tbody > tr > td > table > tbody > tr > td {
  border-top: none !important;
  padding: 0;
}
/*# sourceMappingURL=substances-warnings.component.css.map */
